var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! Vamos observar o seu desempenho técnico na perspectiva das responsabilidades? "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Autoavaliação")]),
      _c("p", [
        _vm._v(" Na aba "),
        _c("span", { staticClass: "info--text" }, [_vm._v(" AUTOAVALIAÇÃO")]),
        _vm._v(
          " você visualiza seus resultados indicando a nota máxima e a nota da sua autoavaliação em cada responsabilidade. É possível visualizar também as competências técnicas de cada responsabilidade. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Avaliação do gestor")]),
      _c("p", [
        _vm._v(" Na aba "),
        _c("span", { staticClass: "info--text" }, [
          _vm._v(" AVALIAÇÃO DO GESTOR"),
        ]),
        _vm._v(
          " você visualiza seus resultados, indicando a nota máxima e a nota atribuída por seu gestor para cada responsabilidade. É possível visualizar também as competências técnicas de cada responsabilidade. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Meu resultado")]),
      _c("p", [
        _vm._v(" Na aba "),
        _c("span", { staticClass: "info--text" }, [_vm._v(" MEU RESULTADO")]),
        _vm._v(
          " você visualiza a responsabilidade direcionada para o desenvolvimento. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("ul", [
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(" A coluna "),
              _c("span", { staticClass: "error--text" }, [_vm._v("Resultado")]),
              _vm._v(
                " utilizou a ponderação 40% (autoavaliação) + 60% (nota gestor) "
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Para mais esclarecimentos, consulte os normativos do Programa disponíveis no site: "
              ),
              _c(
                "a",
                {
                  attrs: { href: "http://desenvolva.ufc.br", target: "_blank" },
                },
                [_vm._v(" desenvolva.ufc.br ")]
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Você pode imprimir todos os resultados na opção baixar PDF. "
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }